export default __webpack_public_path__ + "static/rightimg-d01685ac511e7d56503f6cc96700d361.png";